import _get from 'lodash/get'

export function mounted() {
  this.amenityID = _get(this.$route.params, 'id', 0)

  if (this.isDebug === true) console.debug('amenityId=' + this.amenityID)
}
